import i18n from 'constants/translation/i18n';

const dependencyAreas = (t?: any) => {
  const entries = [
    {
      area: 'gapsAuditsSolutions',
      title: t
        ? t('BRU_GAPS_AUDITS_SOLUTIONS')
        : 'BRU - Gaps, Audits, Solutions',
      href: '/dependencies/gaps_audits_solutions'
    },
    {
      area: 'evidences',
      title: t ? t('BRU_EVIDENCES') : 'BRU - Evidences',
      href: '/dependencies/evidences'
    }
  ];
  return entries;
};

export default dependencyAreas;
